import(/* webpackMode: "eager" */ "/vercel/path0/frontend/src/components/ui/link/link.tsx");
import(/* webpackMode: "eager" */ "/vercel/path0/frontend/src/components/ui/vector/vector.tsx");
import(/* webpackMode: "eager" */ "/vercel/path0/frontend/src/forms/contact-form/contact-form.tsx")